import React, { PureComponent } from 'react';
import {
	FormInputWithLabelRow,
	TextInputRow,
	SelectInputRow,
	CheckboxInputRow
} from '../../../../reactcomponents/Form';
import { NoFlipMultiSelect } from '../../../../reactcomponents/Dropdown';
import { 
	WHATSAPP_LANGUAGE_CODES,
	WHATSAPP_TEMPLATE_CATEGORIES,
	WHATSAPP_PARAMETER_FORMATS
} from './constants';
import { OBJ_ID_NAME } from '../../../../common/v5/constants';
import { I } from '../../../../common/v5/config';
import styled from 'styled-components';
import { composeWithDisplayName, withUnmountWhenHidden } from '../../../../reactcomponents/hocs';
import { memo } from 'react';
import './edit.css';

const StyledHeadDiv = styled.div`
  div& {
    display: flex;
    .left, .right{
	width: 50%;
	margin-left: 10px;
    }
    & + & {
      padding-top: 5px;
    }
  }
`
const DivH = composeWithDisplayName(
  'Div',
  withUnmountWhenHidden,
  memo
)(StyledHeadDiv)

const StyledIntDiv = styled.div`
  div& {
    display: flex;
    .left, .right {
      width: 50%;
      border: 1px dashed #ccceee;
      margin-left: 2px;
    }
    & + & {
      padding-top: 5px;
    }
  }
`
const Div = composeWithDisplayName(
  'Div',
  withUnmountWhenHidden,
  memo
)(StyledIntDiv)

class WhatsAppButtonSection extends PureComponent {
	constructor(props) {
		super(props);
	}
	handleTextInputChange = (idx, e) => {
		let lv = {
			id: idx + 1, // Buttons use 1-based IDs
			name: e.target.name,
			value: e.target.value
		}
		this.props.buttonChangeData(lv);
	}
	onHandleChangeOption = (idx, val) => {
		let lv = {
			id: idx + 1, // Buttons use 1-based IDs
			name: "type",
			value: val
		}
		this.props.buttonChangeData(lv);
	}
	render() {
		const { value, hide, buttonsVal } = this.props;
		let section = [];
		let sectionContent = [];
		for(let i = 1; i <= value; i++){
			let sv = buttonsVal[i-1] || { id: i, value: i, title: "", type: "QUICK_REPLY" };
			let position = 'left';
			if( i % 2 == 0 ){
				position = 'right';
			}
			sectionContent.push(<div className={position} key={i}>
					<div>{I("Button#")} {i}</div>
					<SelectInputRow
						className="admin-text-input"
						id={`button-type-${i}`}
						name={`type-${i}`}
						label={I("Button Type")}
						option={[
							{id: "QUICK_REPLY", name: I("Quick Reply")},
							{id: "URL", name: I("URL")},
							{id: "PHONE_NUMBER", name: I("Phone Number")}
						]}
						value={sv.type || "QUICK_REPLY"}
						onSelect={(val) => this.onHandleChangeOption(i-1, val)}
						helperTxt={I("Select the type of button: Quick Reply (user can tap to send a predefined message), URL (opens a web page), or Phone Number (initiates a call).")}
					/>
					<TextInputRow
						mandatory={true}
						className="admin-text-input-section"
						id={`button-title-${i}`}
						name={`title-${i}`}
						label={I("Button Text")}
						value={sv.title || ""}
						maxLength={"25"}
						onChange={this.handleTextInputChange.bind(this, i-1)}
						helperTxt={I("Button label text. Maximum 25 characters. Alphanumeric characters only.")}
					/>
					{sv.type === "URL" && (
						<TextInputRow
							mandatory={true}
							className="admin-text-input-section"
							id={`button-url-${i}`}
							name={`url-${i}`}
							label={I("URL")}
							value={sv.url || ""}
							onChange={this.handleTextInputChange.bind(this, i-1)}
							placeholder={I("https://example.com")}
							helperTxt={I("URL to be loaded in WhatsApp user's default web browser when tapped.")}
						/>
					)}
					{sv.type === "PHONE_NUMBER" && (
						<TextInputRow
							mandatory={true}
							className="admin-text-input-section"
							id={`button-phone-${i}`}
							name={`phone_number-${i}`}
							label={I("Phone Number")}
							value={sv.phone_number || ""}
							onChange={this.handleTextInputChange.bind(this, i-1)}
							maxLength={"20"}
							placeholder={I("+15550051310")}
							helperTxt={I("Business phone number to be called in the WhatsApp user's default phone app when tapped. Maximum 20 characters. Alphanumeric characters only.")}
						/>
					)}
				</div>);
			if( position == 'right' ){
				section.push(<Div key={i}>{sectionContent}</Div>);
				sectionContent = [];
			}else{
				if( i >= value ){
					section.push(<Div key={i}>{sectionContent}</Div>);
				}
			}
		}
		return (
			<div className="admin-one-form" hidden={hide}>
				{section}
			</div>
		)
	}
}

class ParameterExamplesSection extends PureComponent {
	constructor(props) {
		super(props);
		this.handleParameterChange = this.handleParameterChange.bind(this);
	}

	extractParameters(templateText, format) {
		if (!templateText) return [];
		
		if (format === 'named') {
			// Extract named parameters like {{param_name}}
			const regex = /\{\{(\w+)\}\}/g;
			const matches = [];
			let match;
			const seen = new Set();
			while ((match = regex.exec(templateText)) !== null) {
				if (!seen.has(match[1])) {
					seen.add(match[1]);
					matches.push({ name: match[1], index: matches.length + 1 });
				}
			}
			return matches;
		} else {
			// Extract positional parameters like {{1}}, {{2}}, etc.
			const regex = /\{\{(\d+)\}\}/g;
			const matches = [];
			let match;
			const seen = new Set();
			while ((match = regex.exec(templateText)) !== null) {
				const num = parseInt(match[1], 10);
				if (!seen.has(num)) {
					seen.add(num);
					matches.push({ name: num.toString(), index: num });
				}
			}
			// Sort by index
			return matches.sort((a, b) => a.index - b.index);
		}
	}

	handleParameterChange(paramName, value) {
		this.props.onParameterChange(paramName, value);
	}

	render() {
		const { templateText, parameterFormat, parameterExamples } = this.props;
		const parameters = this.extractParameters(templateText, parameterFormat || 'positional');
		
		if (parameters.length === 0) {
			return null;
		}

		return (
			<div className="admin-one-form wa-param-examples-section">
				<FormInputWithLabelRow label={I('Parameter Examples')} mandatory={false}>
					<div className="wa-param-examples-content">
						{parameters.map((param, idx) => (
							<TextInputRow
								key={param.name}
								id={`param-${param.name}`}
								name={`param-${param.name}`}
								className="admin-text-input"
								label={parameterFormat === 'named' ? `{{${param.name}}}` : `{{${param.index}}}`}
								value={parameterExamples && parameterExamples[param.name] ? parameterExamples[param.name] : ""}
								onChange={(e) => this.handleParameterChange(param.name, e.target.value)}
								placeholder={I("Enter example value")}
							/>
						))}
					</div>
				</FormInputWithLabelRow>
			</div>
		);
	}
}

class TemplatePreview extends PureComponent {
	generatePreview() {
		const { header, body, footer, parameterFormat, parameterExamples, buttons } = this.props;
		
		let previewBody = body || "";
		
		// Replace parameters with example values
		if (parameterFormat === 'named') {
			// Replace named parameters like {{param_name}}
			if (parameterExamples) {
				Object.keys(parameterExamples).forEach(paramName => {
					const regex = new RegExp(`\\{\\{${paramName}\\}\\}`, 'g');
					previewBody = previewBody.replace(regex, parameterExamples[paramName] || `{{${paramName}}}`);
				});
			}
		} else {
			// Replace positional parameters like {{1}}, {{2}}
			if (parameterExamples) {
				Object.keys(parameterExamples).forEach(paramIndex => {
					const regex = new RegExp(`\\{\\{${paramIndex}\\}\\}`, 'g');
					previewBody = previewBody.replace(regex, parameterExamples[paramIndex] || `{{${paramIndex}}}`);
				});
			}
		}

		return {
			header: header || "",
			body: previewBody,
			footer: footer || "",
			buttons: buttons || []
		};
	}

	render() {
		const preview = this.generatePreview();
		const hasContent = preview.header || preview.body || preview.footer || (preview.buttons && preview.buttons.length > 0);

		if (!hasContent) {
			return (
				<div className="admin-one-form wa-template-preview-section">
					<FormInputWithLabelRow label={I('Template Preview')} mandatory={false}>
						<div className="wa-template-preview-empty">
							{I("Enter template content to see preview")}
						</div>
					</FormInputWithLabelRow>
				</div>
			);
		}

		return (
			<div className="admin-one-form wa-template-preview-section">
				<FormInputWithLabelRow label={I('Template Preview')} mandatory={false}>
					<div className="wa-template-preview-container">
						{/* WhatsApp-style message bubble - matches screenshot style */}
						<div className="wa-message-bubble">
							{/* Header/Title - bold at top */}
							{preview.header && (
								<div className="wa-message-header">
									{preview.header}
								</div>
							)}
							{/* Body text */}
							<div className={preview.footer ? "wa-message-body" : "wa-message-body wa-message-body-no-footer"}>
								{preview.body || I("(No body content)")}
							</div>
							{/* Footer - smaller, italic */}
							{preview.footer && (
								<div className="wa-message-footer">
									{preview.footer}
								</div>
							)}
							{/* Timestamp - like in screenshot */}
							<div className="wa-message-timestamp">
								20:10
							</div>
						</div>
						
						{/* Buttons preview - shown below message bubble, like in screenshot */}
						{preview.buttons && preview.buttons.length > 0 && (
							<div className="wa-buttons-preview">
								{preview.buttons.map((button, idx) => {
									if (!button || !button.title) return null;
									
									// URL and Phone Number buttons - full width, blue with icon
									if (button.type === 'URL' || button.type === 'PHONE_NUMBER') {
										return (
											<div key={idx} className={button.type === 'URL' ? 'wa-button-url' : 'wa-button-phone'}>
												{button.type === 'URL' && (
													<span className="wa-button-url-icon">🔗</span>
												)}
												{button.type === 'PHONE_NUMBER' && (
													<span className="wa-button-phone-icon">📞</span>
												)}
												<span>{button.title}</span>
											</div>
										);
									} else {
										// QUICK_REPLY - smaller, rounded pills
										return (
											<div key={idx} className="wa-button-quick-reply">
												{button.title}
											</div>
										);
									}
								})}
							</div>
						)}
					</div>
				</FormInputWithLabelRow>
			</div>
		);
	}
}

class WhatsAppTemplateEdit extends PureComponent {
	constructor(props) {
		super(props);
		this.handleToggleArea = this.handleToggleArea.bind(this);
		this.handleSelectArea = this.handleSelectArea.bind(this);
		this.handleTemplateChange = this.handleTemplateChange.bind(this);
		this.handleHeaderChange = this.handleHeaderChange.bind(this);
		this.handleFooterChange = this.handleFooterChange.bind(this);
		this.isInteractiveChange = this.isInteractiveChange.bind(this);
		this.onChangeInteractiveTemplates = this.onChangeInteractiveTemplates.bind(this);
		this.handleButtonOptionChange = this.handleButtonOptionChange.bind(this);
		this.handleParameterChange = this.handleParameterChange.bind(this);
		this.state = {
			showArea: false,
			parameterExamples: {},
			whatsappAccounts: [],
			statusLoading: false,
			statusError: null,
			validationErrors: [],
			backendError: null
		};
	}

	handleSelectArea(val) {
		this.props.onHandleChangeData(val, "selectedArea");
		// Load WhatsApp accounts for all selected areas
		if (val) {
			this.loadWhatsAppAccounts(val);
		} else {
			this.setState({ whatsappAccounts: [] });
		}
	}

	loadWhatsAppAccounts(selectedAreas) {
		if (this.props.input && this.props.input.whatsappAccounts && 
			Array.isArray(this.props.input.whatsappAccounts) && 
			this.props.input.whatsappAccounts.length > 0) {
			this.setState({ whatsappAccounts: this.props.input.whatsappAccounts });
			return;
		}
		
		// Fetch WhatsApp accounts from API
		if (!selectedAreas || (Array.isArray(selectedAreas) && selectedAreas.length === 0)) {
			this.setState({ whatsappAccounts: [] });
			return;
		}
		
		let areaIds = [];
		if (typeof selectedAreas === 'string') {
			areaIds = selectedAreas.split(',').map(id => parseInt(id.trim())).filter(id => !isNaN(id));
		} else if (Array.isArray(selectedAreas)) {
			areaIds = selectedAreas.map(id => typeof id === 'number' ? id : parseInt(id)).filter(id => !isNaN(id));
		}
		
		if (areaIds.length === 0) {
			this.setState({ whatsappAccounts: [] });
			return;
		}
		
		const webserverRoot = window.webserverRoot || 
			(window.location.protocol + "//" + window.location.hostname + 
			 (process.env.PATH_PREFIX || "/Cention/web/"));
		
		// Fetch all WhatsApp accounts from admin endpoint
		$.get(webserverRoot + 'admin/account/whatsapp')
			.done((data) => {
				let allAccounts = [];
				
				// Handle different response formats
				if (Array.isArray(data)) {
					allAccounts = data;
				} else if (data && Array.isArray(data.accounts)) {
					allAccounts = data.accounts;
				} else if (data && Array.isArray(data.data)) {
					allAccounts = data.data;
				}
				
				// Filter accounts by selected areas and enabled status
				const filteredAccounts = allAccounts.filter(acc => {
					const accountAreaId = acc.areaID || acc.areaId || acc.area_id;
					const isInSelectedArea = areaIds.includes(accountAreaId);
					const isEnabled = acc.enabled === true || acc.enabled === 'true' || acc.Enabled === true;
					return isInSelectedArea && isEnabled;
				});
				
				// Transform to the format expected by SelectInputRow
				const waAccounts = filteredAccounts.map(acc => {
					const accountId = acc.id || acc.Id;
					const accountID = acc.accountID || acc.AccountID || acc.accountId;
					const accountName = acc.name || acc.Name || acc.accountName || acc.AccountName || `WhatsApp Account ${accountId}`;
					
					return {
						id: accountId,
						name: accountName,
						value: `${accountId}#whatsapp-${accountID}`,
						accountID: accountID
					};
				});
				
				this.setState({ whatsappAccounts: waAccounts });
			})
			.fail((xhr) => {
				console.error("[WhatsAppTemplateEdit] Error fetching WhatsApp accounts:", xhr);
				console.error("[WhatsAppTemplateEdit] Response status:", xhr.status);
				console.error("[WhatsAppTemplateEdit] Response text:", xhr.responseText);
				
				const firstAreaId = areaIds[0];
				
				$.post(webserverRoot + 'errand/areaData', { areas: firstAreaId })
					.done((data) => {
						let waAccounts = [];
						if (data && data.mcam && data.mcam.channels) {
							data.mcam.channels.forEach((channel) => {
								if (channel.type === "Result" && channel.content) {
									try {
										const areaData = typeof channel.content === 'string' 
											? JSON.parse(channel.content) 
											: channel.content;
										if (areaData.waAccounts && Array.isArray(areaData.waAccounts)) {
											waAccounts = areaData.waAccounts;
										}
									} catch (e) {
										console.error("[WhatsAppTemplateEdit] Error parsing area data:", e);
									}
									}
								});
						}
						this.setState({ whatsappAccounts: waAccounts });
					})
					.fail((xhr) => {
						console.error("[WhatsAppTemplateEdit] Fallback also failed:", xhr);
						this.setState({ whatsappAccounts: [] });
					});
			});
	}

	handleToggleArea() {
		this.setState({showArea: !this.state.showArea});
	}

	handleTemplateChange(event) {
		const value = event.target.value;
		this.props.onHandleChangeData(value, "template");
		this.props.onHandleChangeData(value, "htmlContent");
		this.props.onHandleChangeData(value, "plainContent");
	}

	handleHeaderChange(event) {
		this.props.onHandleChangeData(event.target.value, "header");
	}

	handleFooterChange(event) {
		this.props.onHandleChangeData(event.target.value, "footer");
	}

	isInteractiveChange(checked, field) {
		this.props.onChangeInteractive(field, checked);
	}

	onChangeInteractiveTemplates(input, val) {
		this.props.onChangeInteractive(input, val);
	}

	handleButtonOptionChange(val) {
		const buttonCount = val || 1;
		this.props.onChangeInteractive("numberOption", buttonCount);
		// Ensure buttons array has enough elements with proper structure
		const { interactive, onChangeInteractive } = this.props;
		const buttons = interactive.buttons || [];
		const updatedButtons = [...buttons];
		while (updatedButtons.length < buttonCount) {
			const newId = updatedButtons.length + 1;
			updatedButtons.push({ id: newId, value: newId, title: "", type: "QUICK_REPLY" });
		}
		while (updatedButtons.length > buttonCount) {
			updatedButtons.pop();
		}
		onChangeInteractive("buttons", updatedButtons);
	}

	buttonChange = (lv) => {
		const { interactive, onChangeInteractive } = this.props;
		const buttons = interactive.buttons || [];
		const updatedButtons = [...buttons];
		const buttonIndex = lv.id - 1; // Convert 1-based ID to 0-based index
		
		// Ensure button exists
		if (!updatedButtons[buttonIndex]) {
			updatedButtons[buttonIndex] = { id: lv.id, value: lv.id, title: "", type: "QUICK_REPLY" };
		}
		
		// Handle different field names
		if (lv.name.startsWith("title-")) {
			updatedButtons[buttonIndex] = {
				...updatedButtons[buttonIndex],
				title: lv.value
			};
		} else if (lv.name.startsWith("url-")) {
			updatedButtons[buttonIndex] = {
				...updatedButtons[buttonIndex],
				url: lv.value
			};
		} else if (lv.name.startsWith("phone_number-")) {
			updatedButtons[buttonIndex] = {
				...updatedButtons[buttonIndex],
				phone_number: lv.value
			};
		} else if (lv.name === "type") {
			updatedButtons[buttonIndex] = {
				...updatedButtons[buttonIndex],
				type: lv.value
			};
		}
		onChangeInteractive("buttons", updatedButtons);
	}

	handleParameterChange(paramName, value) {
		this.setState(prevState => ({
			parameterExamples: {
				...prevState.parameterExamples,
				[paramName]: value
			}
		}));
		// Also save to input for persistence
		if (this.props.onHandleChangeData) {
			const currentExamples = this.props.input.parameterExamples || {};
			this.props.onHandleChangeData({
				...currentExamples,
				[paramName]: value
			}, "parameterExamples");
		}
	}

	getValidationErrors() {
		const { input, interactive } = this.props;
		const errors = [];

		// Required fields validation
		if (!input.selectedArea || 
			(Array.isArray(input.selectedArea) && input.selectedArea.length === 0) ||
			(typeof input.selectedArea === 'string' && input.selectedArea.trim() === '')) {
			errors.push(I("Area is required"));
		}

		if (!input.whatsappAccountId || input.whatsappAccountId.toString().trim() === '') {
			errors.push(I("WhatsApp Account is required"));
		}

		if (!input.name || input.name.trim() === '') {
			errors.push(I("Template Name is required"));
		}

		if (!input.category || input.category.trim() === '') {
			errors.push(I("Category is required"));
		}

		if (!input.languagecode || input.languagecode.trim() === '') {
			errors.push(I("Language Code is required"));
		}

		if (!input.elementname || input.elementname.trim() === '') {
			errors.push(I("Element Name is required"));
		} else {
			// Element name validation: no spaces, only alphanumeric and underscores
			const elementName = input.elementname.trim();
			if (/\s/.test(elementName)) {
				errors.push(I("Element Name cannot contain spaces"));
			}
			if (!/^[a-zA-Z0-9_]+$/.test(elementName)) {
				errors.push(I("Element Name can only contain letters, numbers, and underscores"));
			}
		}

		// Body is required
		const bodyText = input.htmlContent || input.template || '';
		if (!bodyText || bodyText.trim() === '') {
			errors.push(I("Body text is required"));
		}

		// Buttons are optional - no validation needed

		return errors;
	}

	handleRefreshStatus = () => {
		const { input } = this.props;
		const templateId = input.id || input.itemId || (this.props.activeId ? parseInt(this.props.activeId) : null);
		
		if (!templateId) {
			this.setState({ statusError: I("Template ID not found. Please save the template first.") });
			return;
		}

		this.setState({ statusLoading: true, statusError: null });

		const webserverRoot = window.webserverRoot || 
			(window.location.protocol + "//" + window.location.hostname + 
			 (process.env.PATH_PREFIX || "/Cention/web/"));

		$.get(webserverRoot + 'admin/template/status/' + templateId)
			.done((data) => {
				if (data && data.status) {
					// Update the status in the input
					if (this.props.onHandleChangeData) {
						this.props.onHandleChangeData(data.status, "metaTemplateStatus");
						// Also update metaTemplateId if returned
						if (data.metaTemplateId) {
							this.props.onHandleChangeData(data.metaTemplateId, "metaTemplateId");
						}
					}
					this.setState({ statusLoading: false, statusError: null });
					
					// Show success message
					if (window.showMessage) {
						window.showMessage(I("Template status updated: ") + data.status, "success");
					}
				} else if (data && data.error) {
					this.setState({ 
						statusLoading: false, 
						statusError: data.error 
					});
				} else {
					this.setState({ 
						statusLoading: false, 
						statusError: I("Unknown response from server") 
					});
				}
			})
			.fail((xhr) => {
				let errorMsg = I("Failed to refresh template status");
				if (xhr.responseJSON && xhr.responseJSON.error) {
					errorMsg = xhr.responseJSON.error;
				} else if (xhr.statusText) {
					errorMsg = I("Error: ") + xhr.statusText;
				}
				this.setState({ 
					statusLoading: false, 
					statusError: errorMsg 
				});
			});
	}

	getStatusColor(status) {
		if (!status) return '#6c757d';
		const upperStatus = status.toUpperCase();
		if (upperStatus === 'APPROVED' || upperStatus === 'ACTIVE') return '#28a745';
		if (upperStatus === 'PENDING' || upperStatus === 'IN_REVIEW') return '#ffc107';
		if (upperStatus === 'REJECTED' || upperStatus === 'DISABLED' || upperStatus === 'PAUSED') return '#dc3545';
		return '#6c757d';
	}

	getStatusClass(status) {
		if (!status) return 'unknown';
		const upperStatus = status.toUpperCase();
		if (upperStatus === 'APPROVED' || upperStatus === 'ACTIVE') return 'approved';
		if (upperStatus === 'PENDING' || upperStatus === 'IN_REVIEW') return 'pending';
		if (upperStatus === 'REJECTED' || upperStatus === 'DISABLED' || upperStatus === 'PAUSED') return 'rejected';
		return 'unknown';
	}

	componentDidMount() {
		
		// Load parameter examples from input if available
		if (this.props.input && this.props.input.parameterExamples) {
			this.setState({
				parameterExamples: this.props.input.parameterExamples
			});
		}
		// Load WhatsApp accounts from input if available
		if (this.props.input && this.props.input.whatsappAccounts) {
			this.setState({
				whatsappAccounts: this.props.input.whatsappAccounts
			});
		}
		// If area is already selected, load WhatsApp accounts
		if (this.props.input && this.props.input.selectedArea) {
			const selectedArea = this.props.input.selectedArea;
			
			if (selectedArea && ((Array.isArray(selectedArea) && selectedArea.length > 0) || 
			    (typeof selectedArea === 'string' && selectedArea.trim() !== ''))) {
				this.loadWhatsAppAccounts(selectedArea);
			}
		}
	}

	componentDidUpdate(prevProps) {
		// Update parameter examples when input changes (e.g., when loading a template)
		if (this.props.input && this.props.input.parameterExamples && 
			prevProps.input && prevProps.input.parameterExamples !== this.props.input.parameterExamples) {
			this.setState({
				parameterExamples: this.props.input.parameterExamples
			});
		}
		
		// Check if selectedArea changed and load WhatsApp accounts
		const prevArea = prevProps.input && prevProps.input.selectedArea;
		const currentArea = this.props.input && this.props.input.selectedArea;
		
		if (prevArea !== currentArea && currentArea && 
		    ((Array.isArray(currentArea) && currentArea.length > 0) || 
		     (typeof currentArea === 'string' && currentArea.trim() !== ''))) {
			this.loadWhatsAppAccounts(currentArea);
		} else if (prevArea !== currentArea && (!currentArea || 
		    (Array.isArray(currentArea) && currentArea.length === 0) || 
		    (typeof currentArea === 'string' && currentArea.trim() === ''))) {
			this.setState({ whatsappAccounts: [] });
		}
		
		if (this.props.input && this.props.input.whatsappAccounts && 
			prevProps.input && (!prevProps.input.whatsappAccounts || 
			JSON.stringify(prevProps.input.whatsappAccounts) !== JSON.stringify(this.props.input.whatsappAccounts))) {
			this.setState({
				whatsappAccounts: this.props.input.whatsappAccounts
			});
		}
		
		// Auto-select single WhatsApp account if only one is available and nothing is selected
		// This fixes the issue where SelectionBox doesn't show the dropdown with only one option
		const accounts = this.state.whatsappAccounts || this.props.input.whatsappAccounts || [];
		const prevInputAccounts = prevProps.input && prevProps.input.whatsappAccounts || [];
		const prevAccounts = prevInputAccounts || [];
		
		// Check if accounts changed (state or input props)
		const accountsChanged = JSON.stringify(accounts) !== JSON.stringify(prevAccounts);
		
		// Auto-select if: accounts changed, we have exactly one account, and nothing is selected
		if (accountsChanged && accounts.length === 1 && !this.props.input.whatsappAccountId) {
			const singleAccount = accounts[0];
			const accountId = singleAccount.id || (singleAccount.value ? singleAccount.value.split('#')[0] : null);
			if (accountId && this.props.onHandleChangeData) {
				console.log("[WhatsAppTemplateEdit] Auto-selecting single WhatsApp account in componentDidUpdate:", {
					accountId,
					account: singleAccount,
					accountsCount: accounts.length,
					prevAccountsCount: prevAccounts.length
				});
				this.props.onHandleChangeData(accountId, "whatsappAccountId");
			}
		}
		
		// If category changes from MARKETING to something else, disable interactive
		if (prevProps.input && this.props.input && 
			prevProps.input.category === 'MARKETING' && 
			this.props.input.category !== 'MARKETING') {
			this.props.onChangeInteractive("isInteractive", false);
			this.props.onChangeInteractive("numberOption", 1);
			this.props.onChangeInteractive("buttons", []);
		}
	}

	render() {
		const {
			input,
			areaList,
			interactive,
			onHandleTextInputChange,
			onHandleChangeData,
			onHandleTextInputBlur,
			onChangeInteractive,
			warning
		} = this.props;

		if (!input) {
			return null;
		}

		// Ensure interactive has default values
		const interactiveState = interactive || {
			isInteractive: false,
			numberOption: 1,
			buttons: []
		};

		const buttonCount = interactiveState.numberOption || 1;
		const buttons = interactiveState.buttons || [];
		
		// Get parameter examples from state or input
		const parameterExamples = this.state.parameterExamples || input.parameterExamples || {};

		const validationErrors = this.getValidationErrors();
		const { backendError } = this.state;
		
		// Only show validation errors if form has been interacted with (user has started filling fields)
		// This prevents showing errors by default when creating a new template
		const hasInteracted = input && (
			(input.name && input.name.trim() !== '') ||
			(input.selectedArea && 
				((Array.isArray(input.selectedArea) && input.selectedArea.length > 0) ||
				 (typeof input.selectedArea === 'string' && input.selectedArea.trim() !== ''))) ||
			(input.category && input.category.trim() !== '') ||
			(input.languagecode && input.languagecode.trim() !== '') ||
			(input.elementname && input.elementname.trim() !== '') ||
			(input.whatsappAccountId && input.whatsappAccountId.toString().trim() !== '') ||
			((input.htmlContent || input.template) && (input.htmlContent || input.template).trim() !== '')
		);
		
		// Show errors only if user has interacted with the form
		const shouldShowErrors = hasInteracted && (validationErrors.length > 0 || backendError);

		return (
			<div className="admin-one-form">
				{/* Validation Errors */}
				{shouldShowErrors && (
					<div className="wa-validation-errors">
						<h4 className="wa-validation-errors-title">
							{I('Validation Errors:')}
						</h4>
						<ul className="wa-validation-errors-list">
							{validationErrors.map((error, index) => (
								<li key={index} className="wa-validation-error-item">
									{error}
								</li>
							))}
							{backendError && (
								<li className="wa-validation-error-item wa-validation-error-backend">
									{backendError}
								</li>
							)}
						</ul>
					</div>
				)}
				{/* Area Selection */}
				<FormInputWithLabelRow
					label={I('Area')}
					mandatory={true}
					warning={warning}
				>
					<NoFlipMultiSelect
						id={"area"}
						title={I("Select Area")}
						className="popup-multi-select"
						overrideTitle={true}
						groupSelect={true}
						nested={{key: 'Areas'}}
						data={areaList}
						idFields={OBJ_ID_NAME}
						selected={input.selectedArea}
						onSelect={this.handleSelectArea}
						onToggle={this.handleToggleArea}
						show={this.state.showArea}
						selectAll={true}
						selectNone={true}
						enableSearch={true}
					/>
				</FormInputWithLabelRow>

				{/* WhatsApp Account Selection */}
				{(() => {
					const accounts = this.state.whatsappAccounts || input.whatsappAccounts || [];
					const options = accounts.map(acc => {
						// Ensure we have the correct format for SelectionBox
						const value = acc.value || `${acc.id}#whatsapp-${acc.accountID || acc.id}`;
						const name = acc.name || acc.Name || `WhatsApp Account ${acc.id || 'Unknown'}`;
						return {
							id: value,
							name: name
						};
					});
					
					
					// Check if area is selected but no accounts available
					const hasSelectedArea = input.selectedArea && 
						((Array.isArray(input.selectedArea) && input.selectedArea.length > 0) ||
						 (typeof input.selectedArea === 'string' && input.selectedArea.trim() !== ''));
					const noAccountsAvailable = hasSelectedArea && accounts.length === 0;
					
					return (
						<div>
							<SelectInputRow
								id="whatsappAccountId"
								name="whatsappAccountId"
								className="admin-text-input"
								label={I('WhatsApp Account')}
								value={input.whatsappAccountId ? (() => {
									const account = accounts.find(acc => {
										const accValue = acc.value || `${acc.id}#whatsapp-${acc.accountID || acc.id}`;
										const accId = acc.id || (acc.value ? acc.value.split('#')[0] : null);
										return (accId && accId.toString() === input.whatsappAccountId.toString()) ||
										       (accValue && accValue.split('#')[0] === input.whatsappAccountId.toString());
									});
									if (account) {
										const selectedValue = account.value || `${account.id}#whatsapp-${account.accountID || account.id}`;
										return selectedValue;
									}
									// If not found, return the ID as-is 
									return input.whatsappAccountId;
								})() : ""}
								onSelect={(val) => {
									// Extract account ID from value format: "id#whatsapp-accountID"
									const accountId = val && val.split ? val.split('#')[0] : val;
									onHandleChangeData(accountId, "whatsappAccountId");
								}}
								option={options}
								mandatory={true}
								textNoItemSelected={noAccountsAvailable ? I("No WhatsApp accounts available") : I("Select WhatsApp account")}
								helperTxt={I("Select the WhatsApp account to use for sending this template to Meta API. The account must be enabled and configured with WABA ID and Bearer Token.")}
							/>
							{noAccountsAvailable && (
								<div className="wa-no-accounts-warning">
									<p className="wa-no-accounts-warning-title">
										<strong>{I("No WhatsApp accounts available")}</strong>
									</p>
									<p className="wa-no-accounts-warning-text">
										{I("The selected area does not have any enabled WhatsApp accounts configured. Please configure and enable a WhatsApp account for this area in the area settings.")}
									</p>
								</div>
							)}
						</div>
					);
				})()}

				{/* Template Name */}
				<TextInputRow
					id="name"
					name="name"
					className="admin-text-input"
					label={I("Name")}
					value={input.name ? input.name : ""}
					onChange={onHandleTextInputChange}
					onBlur={onHandleTextInputBlur}
					mandatory={true}
					warning={warning}
				/>

				{/* Meta Template Status - Only show if template has been sent to Meta */}
				{(() => {
					// Try multiple ways to get the template ID
					const templateId = input.id || input.itemId || (this.props.activeId ? parseInt(this.props.activeId) : null);
					const hasMetaId = input.metaTemplateId;
					return templateId && hasMetaId;
				})() && (
					<FormInputWithLabelRow
						label={I('Meta Template Status')}
						mandatory={false}
					>
						<div className="wa-status-container">
							<div className="wa-status-display">
								<strong className="wa-status-text">{I("Status")}:</strong> {' '}
								<span className={`wa-status-value ${this.getStatusClass(input.metaTemplateStatus || 'UNKNOWN')}`}>
									{input.metaTemplateStatus || I("Unknown")}
								</span>
								{input.metaTemplateId && (
									<span className="wa-status-meta-id">
										({I("ID")}: {input.metaTemplateId})
									</span>
								)}
							</div>
							<button
								type="button"
								onClick={this.handleRefreshStatus}
								disabled={this.state.statusLoading}
								className="wa-refresh-button"
								title={I("Refresh template status from Meta API")}
							>
								{this.state.statusLoading ? (
									<>
										<span className="spinner-border spinner-border-sm wa-refresh-spinner"></span>
										{I("Refreshing...")}
									</>
								) : (
									<>
										<span>🔄</span>
										{I("Refresh Status")}
									</>
								)}
							</button>
						</div>
						{this.state.statusError && (
							<div className="wa-status-error">
								{this.state.statusError}
							</div>
						)}
						<div className="wa-status-help">
							{I("Click 'Refresh Status' to check the latest approval status from Meta. Statuses: PENDING (under review), APPROVED (active), REJECTED (needs changes).")}
						</div>
					</FormInputWithLabelRow>
				)}

				{/* Category - Required */}
				<SelectInputRow
					id="category"
					name="category"
					className="admin-text-input"
					label={I('Category')}
					value={input.category ? input.category : ""}
					onSelect={(val) => onHandleChangeData(val, "category")}
					option={WHATSAPP_TEMPLATE_CATEGORIES.map(cat => ({
						id: cat.id,
						name: cat.name
					}))}
					mandatory={true}
					placeholder={I("Select category")}
					helperTxt={I("Select the template category. Authentication templates are for OTP/verification codes. Marketing templates are for promotional messages. Utility templates are for transactional messages.")}
				/>

				{/* Parameter Format */}
				<SelectInputRow
					id="parameterformat"
					name="parameterformat"
					className="admin-text-input"
					label={I('Parameter Format')}
					value={input.parameterformat ? input.parameterformat : "positional"}
					onSelect={(val) => onHandleChangeData(val, "parameterformat")}
					option={WHATSAPP_PARAMETER_FORMATS.map(format => ({
						id: format.id,
						name: format.name
					}))}
					placeholder={I("Select parameter format")}
					helperTxt={I("Choose how parameters are formatted in your template. Named format uses {{param_name}}, positional format uses {{1}}, {{2}}, etc.")}
				/>

				{/* Header - Optional */}
				<TextInputRow
					id="header"
					name="header"
					className="admin-text-input"
					label={I('Header')}
					value={input.header ? input.header : ""}
					onChange={this.handleHeaderChange}
					maxLength="60"
					placeholder={I("Enter header text (optional)")}
					helperTxt={I("Optional header text for the template. Maximum 60 characters. Can be text or media (image, video, document).")}
				/>

				{/* Body - Required */}
				<FormInputWithLabelRow 
					label={I('Body')} 
					mandatory={true}
					helperTxt={I("The main content of the template. This is required and can include parameters using {{1}} or {{param_name}} format.")}
				>
					<textarea 
						className="admin-text-input wa-body-textarea"
						value={input.htmlContent || input.template || ""} 
						onChange={this.handleTemplateChange} 
						rows={6}
						maxLength="1024"
						placeholder={I("Enter template body content")}
					/>
				</FormInputWithLabelRow>

				{/* Footer - Optional */}
				<TextInputRow
					id="footer"
					name="footer"
					className="admin-text-input"
					label={I('Footer')}
					value={input.footer ? input.footer : ""}
					onChange={this.handleFooterChange}
					maxLength="60"
					placeholder={I("Enter footer text (optional)")}
					helperTxt={I("Optional footer text for the template. Maximum 60 characters.")}
				/>

				{/* Is interactive? - Only show for Marketing templates */}
				{input.category === 'MARKETING' && (
					<CheckboxInputRow
						label={I("Is interactive?")}
						id={"adminChat-customize"}
						name={"isInteractive"}
						data-qa-id="isInteractive"
						checked={interactiveState.isInteractive || false}
						onChange={(checked) => this.isInteractiveChange(checked, "isInteractive")}
						helperTxt={I("Enable to add interactive buttons to your marketing template. Marketing templates support up to 10 buttons.")}
					/>
				)}

				{/* Buttons Section - Only show for Marketing templates when interactive is enabled */}
				{input.category === 'MARKETING' && interactiveState.isInteractive && (
					<div className="admin-one-form">
						<SelectInputRow
							id="buttoncount"
							name="buttoncount"
							className="admin-text-input"
							label={I('Number of Buttons')}
							value={buttonCount}
							onSelect={this.handleButtonOptionChange}
							option={[
								{id: 1, name: "1"},
								{id: 2, name: "2"},
								{id: 3, name: "3"},
								{id: 4, name: "4"},
								{id: 5, name: "5"},
								{id: 6, name: "6"},
								{id: 7, name: "7"},
								{id: 8, name: "8"},
								{id: 9, name: "9"},
								{id: 10, name: "10"}
							]}
							mandatory={true}
							helperTxt={I("Select the number of buttons (1-10). Marketing templates support up to 10 buttons. Buttons can be quick reply buttons, URL buttons, or call buttons.")}
						/>

						<WhatsAppButtonSection
							value={buttonCount}
							buttonsVal={buttons}
							buttonChangeData={this.buttonChange}
						/>
					</div>
				)}

				{/* Element name */}
				<TextInputRow
					id="elementname"
					name="elementname"
					className="admin-text-input"
					label={I('Element name')}
					value={input.elementname ? input.elementname : ""}
					onChange={onHandleTextInputChange}
					onBlur={onHandleTextInputBlur}
					mandatory={true}
					placeholder={I("Enter element name")}
					helperTxt={I("This is the element name of the template. You will get the element name from WhatsApp during the approval of the template.")}
				/>

				{/* Language Code */}
				<SelectInputRow
					id="languagecode"
					name="languagecode"
					className="admin-text-input"
					label={I('Language Code')}
					value={input.languagecode ? input.languagecode : ""}
					onSelect={(val) => onHandleChangeData(val, "languagecode")}
					option={WHATSAPP_LANGUAGE_CODES.map(lang => ({
						id: lang.id,
						name: lang.name
					}))}
					mandatory={true}
					placeholder={I("Select language code")}
					helperTxt={I("Select the language code for the template. This must match the language specified when creating the template in Meta/WhatsApp Business Manager.")}
				/>

				{/* Parameter Examples Section */}
				<ParameterExamplesSection
					templateText={input.htmlContent || input.template || ""}
					parameterFormat={input.parameterformat || "positional"}
					parameterExamples={parameterExamples}
					onParameterChange={this.handleParameterChange}
				/>

				{/* Template Preview */}
				<TemplatePreview
					header={input.header || ""}
					body={input.htmlContent || input.template || ""}
					footer={input.footer || ""}
					parameterFormat={input.parameterformat || "positional"}
					parameterExamples={parameterExamples}
					buttons={buttons}
				/>
			</div>
		);
	}
}

export default WhatsAppTemplateEdit;
